/*
 * Created Date: 16-01-2024, 10:20:57 am
 * Author: Victor
 * Email: victor@pt-corp.vn
 * -----
 * Last Modified: Wed Mar 13 2024
 * Modified By: Victor
 * -----
 * Copyright (c) 2024 PT CORP, Inc
 * -----
 * HISTORY:
 * Date      	By	Comments
 * ----------	---	----------------------------------------------------------
 */

import React from 'react'
import { ROUTER_WORKSPACE_QUESTION_COLLECTION } from './const'

// const CreateExamUsingAI = React.lazy(() => import('../index'))
const QuestionCollectionListPageLazy = React.lazy(() => import('../pages/ListPage'))
const QuestionCollectionDetailLazy = React.lazy(() => import('../pages/DetailPage'))

export const workspaceQuestionCollectionRouterConfig = {
	auth: [],
	settings: {
		layout: {
			config: {
				sidebar: {
					display: true,
					collapsed: true
				},
				header: {
					display: true
				}
			}
		}
	},
	routes: [
		{
			path: ROUTER_WORKSPACE_QUESTION_COLLECTION.question_collection,
			element: <QuestionCollectionListPageLazy />
		},
		{
			path: ROUTER_WORKSPACE_QUESTION_COLLECTION.detail_question_collection(),
			element: <QuestionCollectionDetailLazy />
		}
	]
}
